module.exports = __webpack_public_path__ + "img/help-icon4.8cd81ae3.png";